export default __webpack_public_path__ + "static/media/D_03_01_bg.15eade06.mp4";